import { render, staticRenderFns } from "./WritingsDoneTable.vue?vue&type=template&id=671243b6&"
import script from "./WritingsDoneTable.vue?vue&type=script&lang=js&"
export * from "./WritingsDoneTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports